// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1Uh45","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__32N7t"};